import { IWidget } from './prisma-xs.model';
import { KitType } from '../../shared/models/prisma-xs.model';
import { ProductStatus } from '../../../modules/shared/models/product.model';

export interface IArticle {
  id?: number;
  uuid?: string;
  eNumber: number;
  deviceId: number;
  ref: string;
  description: string;
  picture3D: string;
  picture2D: string;
  pictures?: string[];
  productType: string;
  widget: IWidget;
  maxFields?: number;
  maxRows?: number;
  minFields?: number;
  minRows?: number;
  price: number;
  rules: IRules;
  kitType: KitType;
  productId: number;
  kitTypeId?: number;
  typeDescription?: string;
  deliverToCustomer: boolean;
  deliverToPanelBuilder: boolean;
  kitOrder?: number;
  isCustomDevice: boolean;
  status?: ProductStatus;
  enclosureId?: number;
  ratedCurrentDescription: string;
  productCharacteristicsLink: string;
  canTransferToWholesaler: boolean;
  replacingProduct: IReplacingProduct
}

export class ArticleModel implements IArticle {
  id: number;
  description: string;
  deviceId: number;
  picture2D: string;
  picture3D: string;
  pictures: string[];
  productType: string;
  productTypeId?: number;
  ref: string;
  eNumber: number;
  uuid: string;
  widget: IWidget;
  maxFields: number;
  maxRows: number;
  kitType: KitType;
  kitTypeId?: number;
  rules: IRules;
  price: number;
  productId: number;
  rowNumber: number;
  columnNumber: number;
  width: number;
  deliverToCustomer: boolean;
  deliverToPanelBuilder: boolean;
  kitOrder?: number;
  isCustomDevice: boolean;
  status?: ProductStatus;
  enclosureId?: number;
  ratedCurrentDescription: string;
  productCharacteristicsLink: string;
  productInfoLink: string;
  canTransferToWholesaler: boolean;
  isNxsDummy?: boolean;
  replacingProduct: IReplacingProduct;
  priceBeforeDiscount?: number;
}

export interface IReplacingProduct {
  eNumber: number;
  ref: string;
  description: string;
  price: number;
  productCharacteristicsLink: string,
  stockLevel: number;
}

export interface IRules {
  kit: {
    noResize: boolean;
    showLabelOnCover: boolean;
  };
  upright?: {
    allowGoTrough: boolean,
    noUprights: boolean;
  };
  placement?: {
    noSameKitAbove: boolean;
    noSameKitAboveAllowedException: boolean;
    cannotBePlacedOn280: boolean;
    cannotBePlacedOnTopOrBottomOfEnclosure: boolean;
    cannotBePlacedOverHorizontalSeparator: boolean;
    blockingKitsAbove: IBlockingKitsAbove
  };
  segregation?: {
    needsMeteringSegregationFromTopAndBottom: boolean;
    wholeFieldSegregation: boolean;
    hasPremountedSegregation?: boolean;
  };
  hasCover?: boolean
}

export interface IBlockingKitsAbove {
  blockingKitsOrderIds: number[],
  exceptions: string[]
}
